import React from "react";
import { Link } from "react-router-dom";
import { startGoogleOAuth } from "../lib/auth";

/**
 * LoginPrompt — inline gate shown on auth-required tabs (Messages, You) when
 * the visitor isn't signed in. Mirrors the visual language of /login but stays
 * embedded inside the destination page so the bottom tab bar never reshuffles.
 * After Google sign-in completes, the user lands back on the same path they
 * were on (Messages / Settings), not Oracle.
 */
export default function LoginPrompt({ title, blurb }) {
  return (
    <div
      data-testid="login-prompt"
      className="max-w-md mx-auto px-6 pt-16 pb-32 md:pb-24 text-center"
    >
      <div className="label mb-6">Threshold</div>
      <h2 className="serif text-3xl sm:text-4xl text-foreground leading-tight">
        {title}
      </h2>
      <p className="mt-4 text-muted-foreground leading-relaxed">{blurb}</p>

      <button
        onClick={() => startGoogleOAuth()}
        data-testid="login-prompt-google"
        className="btn-ghost w-full mt-10 flex items-center justify-center gap-3"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21.35 11.1H12v3.2h5.35c-.55 2.6-2.7 4.5-5.35 4.5a6.3 6.3 0 1 1 0-12.6c1.55 0 3 .55 4.1 1.55l2.3-2.3A9.5 9.5 0 0 0 12 2a10 10 0 1 0 9.35 13.4c.45-1.3.65-2.7.65-4.3z" />
        </svg>
        Continue with Google
      </button>

      <div className="mt-8 text-xs text-muted-foreground">
        <Link
          to="/login"
          data-testid="login-prompt-email-link"
          className="link-underline"
        >
          or sign in with email
        </Link>
      </div>
    </div>
  );
}
